<template>
  <div class="mb-2">
    <div class="row">
      <div class="col-12">
        <div class="titlePage mb-3">Verificação de Alterações por Tipo de Dados Cadastrais</div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <fccTable responsive striped hover :fields="fields" :items="items" />
      </div>
    </div>

    <div class="row">
      <div class="col ml-auto text-right">
        <div class="d-inline-flex">
          <fccButton class="mr-2" @click="$emit('buscar')"> Buscar alterações</fccButton>
          <fccButton @click="importarAlteracoes" class="mr-2" :disabled="items.length === 0">
            Importar alterações
          </fccButton>
          <fccButton @click="$emit('deletar')" :disabled="items.length === 0"> Deletar </fccButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['deletar', 'importar', 'buscar'],
  props: ['items', 'buscaRealizada'],
  data() {
    return {
      fields: [
        { key: 'id_requisicao', label: 'ID Requisição', active: true },
        { key: 'tipodadoscadastrais', label: 'Tipos de Dados Cadastrais', active: true },
        { key: 'nalteracoes', label: 'Nº de Alterações', active: true },
        { key: 'tecnico', label: 'Técnico', active: true },
        { key: 'datarequisicao', label: 'Data da Requisição', active: true }
      ]
    }
  },
  methods: {
    adicionarDadosCadastrais() {
      this.$emit('adicionar', this.items)
    },
    importarAlteracoes() {
      if (this.buscaRealizada) {
        this.$emit('importar')
      } else {
        this.callAlert('Realize a busca antes de importar alterações.')
      }
    }
  }
}
</script>
